import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";
import { PROMISES } from "@/data/site";

export const Promises = () => {
  return (
    <section
      id="versprechen"
      data-testid="promises-section"
      className="relative border-y"
      style={{ borderColor: "var(--lx-border)", background: "rgba(11,15,12,0.5)" }}
    >
      <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 lg:px-8 lg:py-28">
        <div className="mb-12 max-w-2xl">
          <div className="lx-kicker mb-3">Unsere Versprechen</div>
          <h2 className="font-display text-2xl font-semibold tracking-tight text-[color:var(--lx-text)] sm:text-3xl lg:text-4xl">
            Warum du uns vertrauen kannst.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-[color:var(--lx-text-2)]">
            Wir sind ein junges Team, und genau deshalb geben wir dir maximale
            Sicherheit: klare Kosten, echte Betreuung und eine Garantie, die kein
            Risiko offen lässt.
          </p>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4"
        >
          {PROMISES.map((p) => {
            const Icon = p.icon;
            const featured = p.featured;
            return (
              <motion.div
                key={p.title}
                variants={fadeUp}
                data-testid="promise-card"
                className="lx-card group relative overflow-hidden p-6 sm:p-7"
                style={
                  featured
                    ? {
                        borderColor: "rgba(168,232,92,0.4)",
                        background:
                          "linear-gradient(180deg, rgba(168,232,92,0.08), rgba(14,20,16,0.9))",
                      }
                    : undefined
                }
              >
                <div
                  className="mb-5 grid h-12 w-12 place-items-center rounded-[12px] border"
                  style={{
                    borderColor: featured
                      ? "rgba(168,232,92,0.45)"
                      : "var(--lx-border-strong)",
                    background: featured
                      ? "rgba(168,232,92,0.12)"
                      : "var(--lx-surface-2)",
                    color: "var(--lx-green)",
                    boxShadow: featured
                      ? "0 0 22px rgba(168,232,92,0.22)"
                      : "none",
                  }}
                >
                  <Icon size={22} />
                </div>
                {featured && (
                  <span
                    className="mb-2 inline-block font-mono-lx text-[10px] uppercase tracking-[0.2em]"
                    style={{ color: "var(--lx-green-soft)" }}
                  >
                    Kein Risiko
                  </span>
                )}
                <h3 className="font-display text-lg font-semibold text-[color:var(--lx-text)]">
                  {p.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[color:var(--lx-text-2)]">
                  {p.desc}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
